<app-header></app-header>
<div class="contenedor_principal">
    <div class="div-menu-alterno">
        <div class="div-img-titulo-menu-alterno"><img src="./assets/img/iconos/estadisticas-graficas-interactivas.svg"
                class="img-boton-inicio" [routerLink]="['/home']">
            <h3>{{constantes.ETIQUETA_TITULO_APLICACION}}</h3>
        </div>
    </div>
    <div class="contenidoDivTitulo">
        <h3>Gráfica de la serie de datos<img class="imagen-titulo" src="./assets/img/book.png" /></h3>
        <div class="div-linea-titulo"></div>
    </div>
    <div class="div-contenedor-chart-dashboard">
        <div class="div-chart-principal" *ngIf="tabChart == 'chartPI'">
            <div id="play-controls">
                <button id="play-pause-button" class="fa fa-play" title="play"
                    (click)="iniciarAnimacionPreciosInflacion()">
                    <mat-icon *ngIf="accionBotonBarRace === 'play'" aria-hidden="false"
                        class="icon-bar-race">play_arrow</mat-icon>
                    <mat-icon *ngIf="accionBotonBarRace === 'pause'" aria-hidden="false"
                        class="icon-bar-race">pause</mat-icon>
                </button>
                <input id="play-range" type="range" [value]="indiceActual" [min]="barRaceDatoMin" [max]="barRaceDatoMax"
                    (change)="actualizarFechaRango($event)" (input)="actualizarFecha($event)" />
                <span class="span-dato-range">{{fechaSlide}}</span>
            </div>
            <highcharts-chart id="chartPI" class="highcharts-chart-dashboard" [Highcharts]="HighchartsPI"
                [options]="chartOptionsPI" [update]="updateFlag">
            </highcharts-chart>
        </div>

        <div class="div-chart-principal" *ngIf="tabChart == 'chartPICiudad'">
            <highcharts-chart id="chartCiudad" class="highcharts-chart-dashboard" [Highcharts]="HighchartsCiudad"
                [options]="chartOptionsCiudad" [update]="updateFlag">
            </highcharts-chart>
        </div>

        <div class="div-chart-principal" *ngIf="tabChart == 'chartTISF'">
            <highcharts-chart id="chartTISF" class="highcharts-chart-dashboard" [Highcharts]="HighchartsTISF"
                [options]="chartOptionsTISF" [update]="updateFlag">
            </highcharts-chart>
        </div>

        <div *ngIf="tabChart == 'chartOBMRI'">
        </div>

        <div class="div-chart-principal" *ngIf="tabChart == 'chartSETCD'">
            <div id="play-controls">
                <button id="play-pause-button" class="fa fa-play" title="play" (click)="iniciarAnimacionIntradia()">
                    <mat-icon *ngIf="accionBotonIntradiaBarRace === 'play'" aria-hidden="false"
                        class="icon-bar-race">play_arrow</mat-icon>
                    <mat-icon *ngIf="accionBotonIntradiaBarRace === 'pause'" aria-hidden="false"
                        class="icon-bar-race">pause</mat-icon>
                </button>
                <input id="play-range" type="range" [value]="indiceActualIntradia" [min]="barRaceIntradiaMin"
                    [max]="barRaceIntradiaMax" (change)="actualizarFechaRangoIntradia($event)"
                    (input)="actualizarFechaIntradia($event)" />
                <span class="span-dato-range">{{fechaIntradiaSlide}}</span>
            </div>
            <highcharts-chart id="chartIntradia" class="highcharts-chart-dashboard" [Highcharts]="HighchartsIntradia"
                [options]="chartOptionsIntradia" [update]="updateFlag">
            </highcharts-chart>
        </div>

        <div *ngIf="tabChart == 'chartAEMLCF'">
        </div>

        <div *ngIf="tabChart == 'chartSPDP'">
        </div>

    </div>


</div>